import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftrag, IAuftragChangeStatusRequest, IAuftragHinweisRequest, IAuftragHinweisResponse, IAuftragMessage, IAuftragRequest, IAuftragTerminiereRequest, IAuftragWiedervorlageRequest, ISearchAuftragRequest, WriteAuftragMessageDto } from "../types/Types";

/**
 * @author mb
 */
export const FileAPI = createApi({
    reducerPath: "fileAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "file",
            credentials: 'include'
        }),
    tagTypes: ['fileAPI'], // for caching
    endpoints: (builder) => ({
        remove: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/remove/' + uid,
                    method: 'delete',
                    credentials: 'include'
                }),
                invalidatesTags: ["fileAPI"],
            }
        ),
    })
});

export const {
    useRemoveMutation,
} = FileAPI;
